export enum NotificationsType {
	FormAddition = 1,
	RecordAddition = 2,
	RefundsIdentified = 3,
	RefundInvoiceCreation = 4,
	RefundInvoiceReview = 5,
	RefundInvoiceRollback = 6,
	RefundInvoiceIssuance = 7,
	RefundInvoiceSettlement = 8,
	AgreementCreation = 9,
	AgreementApproval = 10,
	AgreementLaunch = 11,
	AgreementCompletion = 12,
	AgreementUserRolesChanges = 13,
	FormSaving = 14,
	FormDueEarly = 15,
	FormDueExact = 16,
	FormOverdueExact = 17,
	FormOverdueGapReminders = 18,
	UserDirectMention = 20,
	ThreadUpdate = 21,
	FormOverdueEqualToZero = 22,
	UserAssigned = 23,
	NegotiableAttributeProposal = 25,
	RefundInvoiceReceiverConfirmation = 26,
	RefundInvoiceReceiverApproval = 27,
	RefundInvoiceReceiverRejection = 28,
	RefundInvoiceSenderConfirmation = 29,
	RefundInvoiceSenderRejection = 30,
	DocumentPaymentReminder = 31,
	RefundInvoiceResendForReview = 32,
	ReviewReminder = 33,
	DocumentAutomatedReviewReminder = 34,
	DocumentCreatorApprovalDualApproval = 35,
	AgreementValidityExpirationReminder = 36,
}
